"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.batchLoggers = void 0;
function batchLoggers(...loggers) {
    return {
        log: (...args) => loggers.forEach(l => l.log(...args)),
        warn: (...args) => loggers.forEach(l => l.warn(...args)),
        error: (...args) => loggers.forEach(l => l.error(...args)),
    };
}
exports.batchLoggers = batchLoggers;
//# sourceMappingURL=batch.js.map